import { Component, OnInit, Input, TemplateRef, ChangeDetectorRef, AfterViewInit } from '@angular/core';

/**
 * This component is intended to be used to create
 * collapsible sections on forms.
 */
@Component({
    selector: 'pcg-collapsible-divider',
    templateUrl: './collapsible-divider.component.html',
    styleUrls: ['./collapsible-divider.component.scss'],
    standalone: false
})
export class CollapsibleDividerComponent implements OnInit, AfterViewInit {
	@Input() visible: boolean = true; // Whether or not section collapsed by default
	@Input() header: string | TemplateRef<any>; // Text that shows in the section header
	@Input() headerText: string; // Text that is read by a screen reader when describing the region
	@Input() headerLevel: number = 2; // Heading level of divider
	headerIsString = false;
	collapseContentId = Math.random().toString(36).substring(2);
	labeledById = Math.random().toString(36).substring(2);

	constructor(private changeDetectorRef: ChangeDetectorRef) {}

	toggle() {
		this.visible = !this.visible;
	}

	ngOnInit() {
		if (typeof this.header === 'string') {
			this.headerIsString = true;
			this.headerText = this.header;
		}
	}

	ngAfterViewInit() {
		this.changeDetectorRef.detectChanges();
	}
}

